import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button, ModalDialog, useToggle, Image,
} from '@openedx/paragon';
import { FormattedMessage, useIntl } from '@edx/frontend-platform/i18n';
import confetti from 'canvas-confetti';
import messages from './AdminOnboardingTours/messages';
import completeModal from './data/images/CompletedModal.svg';
import { completeOnboardingTour } from '../../data/actions/enterpriseCustomerAdmin';

interface TourCompleteModalProps {
  onboardingTourCompleted: boolean;
  adminUuid: string,
  completeOnboardingTour: (adminUuid: string) => void;
}

const TourCompleteModal: React.FC<TourCompleteModalProps> = ({
  onboardingTourCompleted,
  adminUuid,
  completeOnboardingTour: completeTour,
}) => {
  const intl = useIntl();
  const [isOpen, open, close] = useToggle(true);

  useEffect(() => {
    if (!onboardingTourCompleted) {
      open();
    }
  }, [onboardingTourCompleted, open]);

  const handleDismiss = () => {
    // Trigger confetti animation
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#007bff', '#28a745', '#ffc107', '#dc3545', '#6f42c1'],
    });

    close();
    completeTour(adminUuid);
  };

  return (
    <ModalDialog
      title="Onboarding complete modal"
      isOpen={isOpen}
      onClose={close}
      size="sm"
      hasCloseButton={false}
      isFullscreenOnMobile
      isOverflowVisible={false}
    >
      <ModalDialog.Header>
        <Image
          className="modal-image"
          src={completeModal}
          alt="Graphic of person watching an informational video greeting another person"
        />
        <ModalDialog.Title>
          {intl.formatMessage(messages.completeTourModalTitle)}
        </ModalDialog.Title>
      </ModalDialog.Header>

      <ModalDialog.Body>
        <p>
          {intl.formatMessage(messages.completeTourModal)}
        </p>
      </ModalDialog.Body>

      <ModalDialog.Footer>
        <Button onClick={handleDismiss}>
          <FormattedMessage
            id="admin.portal.productTours.adminOnboarding.TourCompleteModal.done"
            defaultMessage="Done"
            description="Label for the done button on the complete tour modal."
          />
        </Button>
      </ModalDialog.Footer>
    </ModalDialog>
  );
};

const mapStateToProps = state => ({
  onboardingTourCompleted: state.enterpriseCustomerAdmin.onboardingTourCompleted as boolean,
});

const mapDispatchToProps = dispatch => ({
  completeOnboardingTour: (adminUuid: string) => {
    dispatch(completeOnboardingTour(adminUuid));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TourCompleteModal);
